import { assoc, compose, pick } from 'ramda'

export const cleanRequest = item => {
  const sla_type = item?.value?.sla_type?.id || item?.value?.sla_type
  const sla_unit = item?.value?.sla_unit?.id || item?.value?.sla_unit
  const sla_value = Number(item.value.sla_value)
  const sla_checklists = item?.value?.checklists || []
  const sla_places = item?.value?.places || []

  const value = {
    sla_type: sla_type,
    sla_unit: sla_unit,
    duration_in_seconds: convertSlaToSeconds(sla_value, sla_unit),
    checklists: sla_checklists,
    places: sla_places
  }

  return compose(pick(['id', 'name', 'value']), assoc('value', JSON.stringify(value)))(item)
}

const unitMultipliers = {
  day: 86400,
  hour: 3600,
  minute: 60
}

const convertSlaToSeconds = (sla_value, sla_unit_id) => {
  if (!sla_value || !sla_unit_id) return 0
  const multiplier = unitMultipliers[sla_unit_id] || 0
  return sla_value * multiplier
}

export const convertSecondsToSla = (seconds, sla_unit_id) => {
  if (!seconds || !sla_unit_id) return 0
  const multiplier = unitMultipliers[sla_unit_id] || 1
  return seconds / multiplier
}
